import React, { FC, useCallback } from 'react';
import { Upload } from 'src/common';
import { useTranslation } from 'react-i18next';
import { useCurrentFolderContext, useUploadFile } from 'src/models/documentsLibrary/hooks';
import { RcFile } from 'antd/lib/upload';
import Button from 'src/common/Button';

export const DocumentsUpload: FC = () => {
  const { t } = useTranslation();
  const currentFolder = useCurrentFolderContext();
  const [uploadFile] = useUploadFile();

  const onUpload = useCallback(
    (file: RcFile) => {
      file && uploadFile(file, currentFolder.id);
      return Upload.LIST_IGNORE;
    },
    [currentFolder.id, uploadFile]
  );

  return (
    <Upload name={'file'} showUploadList={false} method={undefined} beforeUpload={onUpload}>
      <Button type={'primary'}>{t('Common.uploadFile')}</Button>
    </Upload>
  );
};

export default DocumentsUpload;
